const getRandomString = (size) => {
  const chars = 'abcdefghijklmnopqrstuvwxyz012345678';
  let s = '';
  while (s.length < size) {
    s += chars.charAt(Math.random() * chars.length | 0);
  }
  return s;
}

export default {
  getRandomString,
};
